import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = []

  initialize() {
  }

  connect() {
    // var tag = document.createelement('script');
    // tag.src = "https://www.youtube.com/player_api";
    // var firstscripttag = document.getelementsbytagname('script')[0];
    // firstscripttag.parentnode.insertbefore(tag, firstscripttag);
    //
    // // replace the 'ytplayer' element with an <iframe> and
    // // youtube player after the api code downloads.
    // var player;
    // function onyoutubeplayerapiready() {
    //   player = new yt.player('ytplayer', {
    //     height: '360',
    //     width: '640',
    //     videoid: 'fygua3xbsjo'
    //   });
    // }
  }


  onYouTubeIframeAPIReady() {
    console.log("onYouTubeIframeAPIReady");
    player = new YT.Player('ytplayer', {
      videoId: 'fYGua3xBSJo',
      playerVars: {
        controls: 0,
        autoplay: 1,
        disablekb: 1,
        enablejsapi: 1,
        iv_load_policy: 3,
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        loop: 1,
      }
    });
  }


}
